module.exports = __webpack_public_path__ + "static/sermons-3c42c1e72b8bef7226548c73d0103d0d.jpg";